import { isEmpty, isNil } from 'lodash-es';
import { EnergyUsageItem } from '.';
import { TaskScene } from '../../../../const';
import { IndexTimeActive } from '../SwitchDate';
import dayjs from 'dayjs';
import { formatThousandAndUnit, keepTwoOrNullByKey } from '@/utils/utils';
import { formatName, normalizeStackedListUnit } from '@/pages/WgqAllMaps/utils';

export const ChartColors = {
  [TaskScene.ELECTRICITY]: ['#FF6D2C', '#CE90D1', '#0DB6D9', '#63BC7F'],
  [TaskScene.WATER]: [
    '#52E7FF',
    '#FF477B',
    '#FFCB47',
    '#6F47FF',
    '#16DD8E',
    '#2D8DFF',
    '#52C41A',
    '#234ED9',
    '#FF9247',
    '#854ECA',
    '#4A90E2',
    '#FF4D4F',
    '#59D744',
    '#5D7092',
  ],
};

export const getBarChartOption = (chartData?: EnergyUsageItem, timeResolution?: IndexTimeActive) => {
  if (isEmpty(chartData?.chartDataList)) return {};

  const { chartDataList, physicalUnitName, id } = chartData || {};

  const { unit, normalizedData } = normalizeStackedListUnit(chartDataList, {
    listKey: 'usageDataList',
    valueKey: 'value',
    baseUnit: physicalUnitName!,
  });

  const allNames = chartDataList![0]?.usageDataList?.map(u => u.name);

  const series =
    id === TaskScene.ELECTRICITY
      ? allNames!.map(name => ({
          name: `${name}电量`,
          type: 'bar',
          stack: 'total',
          barMaxWidth: 20,
          data: normalizedData!.map(item => {
            const found = item.usageDataList!.find(u => u.name === name);
            return found?.value;
          }),
        }))
      : allNames!.map(name => ({
          name: formatName(name),
          type: 'line',
          smooth: true,
          stack: 'Total',
          areaStyle: {
            opacity: 0.25,
          },
          data: normalizedData!.map(item => {
            const found = item.usageDataList!.find(u => u.name === name);
            return found?.value;
          }),
        }));

  return {
    backgroundColor: 'transparent',
    color: id === TaskScene.ELECTRICITY ? ChartColors[TaskScene.ELECTRICITY] : ChartColors[TaskScene.WATER],
    legend: {
      type: 'scroll',
      right: 8,
      left: series.length > 4 ? 100 : undefined,
      top: 10,
      bottom: 8,
      icon: 'rect',
      textStyle: {
        color: 'rgba(255,255,255,0.85)',
      },
      itemWidth: 12,
      itemHeight: 12,
      itemGap: 16,
      padding: [0, 8, 0, 0],
    },
    tooltip: {
      formatter: (items: any) => {
        let { axisValue } = items[0];
        let otherStr = '';
        let str = '';

        items.forEach((item: any) => {
          const { seriesName, data, marker } = item;
          otherStr += `<div style="margin-top:8px;width:150px;"><div style="display:flex;justify-content:space-between;align-items:center;"><div><span>${marker}</span>${seriesName}</div><div>${
            data ?? '--'
          }${unit}</div></div>`;
          str = axisValue + otherStr;
        });

        return str;
      },
    },
    grid: {
      left: 10,
      right: 10,
      top: 40,
      bottom: 20,
      containLabel: true,
    },
    xAxis: [
      {
        type: 'category',
        boundaryGap: true, // 或直接删掉
        data: normalizedData?.map(item =>
          dayjs(item.time, 'x').format(timeResolution === IndexTimeActive.THIS_MONTH ? 'MM-DD' : 'YYYY-MM')
        ),
      },
    ],
    yAxis: {
      type: 'value',
      name: unit,
    },
    series: series,
  };
};
